export const cookieNamespace = "bs-v1.20";

export function setCookie(name, value, includeNamespace = true) {
  name = includeNamespace ? `${cookieNamespace}-${name}` : name;
  let encodedName = "";
  let encodedValue = "";
  try {
    encodedName = encodeURIComponent(name);
    encodedValue = encodeURIComponent(value);
  } catch (error) {
    return;
  }

  const updatedCookie = {
    [encodedName]: encodedValue,
    sameSite: "lax",
    path: "/",
    expires: new Date(new Date().getFullYear() + 10, 1, 17).toUTCString(),
  };

  document.cookie = Object.entries(updatedCookie)
    .map(kv => kv.join("="))
    .join(";");
}
